import PropTypes from 'prop-types';
import React from 'react';

import RichText from 'components/RichText';
import Settings from 'utils/Settings';
import { colors, cn } from 'utils/Tailwind';

const BrandTenets = ({ className, dataTestId }) => {
  const {
    items = [],
    backgroundColor = colors.grey.DEFAULT,
    textColor = colors.black.DEFAULT,
  } = Settings.brandTenets ?? {};

  if (!items.length) {
    return null;
  }

  return (
    <section
      className={cn('BrandTenets px-10 py-12 lg:py-24', className)}
      style={{ backgroundColor, color: textColor }}
      {...(dataTestId ? { 'data-testid': dataTestId } : {})}
    >
      <div className="grid grid-cols-1 gap-16 lg:grid-cols-3 lg:gap-10">
        {items.map((tenet, index) => (
          <div
            key={tenet.heading}
            className={cn(
              'BrandTenet relative flex flex-col gap-1.5 text-center after:absolute after:-bottom-8 after:left-1/2 after:h-px after:w-36 after:-translate-x-1/2 after:bg-current after:opacity-20 after:content-[""] lg:after:-right-5 lg:after:bottom-auto lg:after:left-auto lg:after:top-1/2 lg:after:h-14 lg:after:w-px lg:after:-translate-y-1/2 lg:after:translate-x-0',
              index === items.length - 1 ? 'after:hidden lg:after:hidden' : 'after:block'
            )}
          >
            <p className="text-lg font-bold uppercase">{tenet.heading}</p>
            <RichText content={tenet.body} className="[&_p:last-child]:!mb-0" />
          </div>
        ))}
      </div>
    </section>
  );
};

BrandTenets.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string,
};

export default BrandTenets;
